<div class="signup-area"  style="margin: 50px 0px ;">
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-6 pl-0">
                <div class="login-left">
                    <!-- <img src="assets/img/Stafflogin-bg.jpg" alt="Login"> -->
                </div>
            </div>
            <div class="col-lg-6 ptb-100">
                <div class="signup-item">
                    <div class="signup-head">
                        <h2>{{'AUTH.LOGIN.STAFFTITLE' | translate}}</h2>
                    </div>
                    <div class="signup-form">
                        <form class="login-form" [formGroup]="loginForm" (ngSubmit)="submit()">
                            <div class="row">
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <input type="text" class="form-control"
                                            placeholder="{{'AUTH.INPUT.PERSONALNO' | translate}}"
                                            formControlName="personalNo" autocomplete="off" readonly
                                            onfocus="this.removeAttribute('readonly');">
                                        <div class="text-danger"
                                            *ngIf="controlHasError('required', 'personalNo',loginForm)">
                                            {{ 'AUTH.VALIDATION.REQUIRED_FIELD'| translate }}
                                        </div>
                                        <!-- <input style="margin-top: 20px;" type="checkbox" id="gridCheck"> -->
                                        <!-- <label style="margin: 0px 10px;">{{'AUTH.GENERAL.REMEMBERME' |
                                            translate}}</label> -->
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <input type="password" class="form-control"
                                            placeholder="{{'AUTH.INPUT.PASSWORD' | translate}}"
                                            formControlName="password">
                                        <div class="text-danger"
                                            *ngIf="controlHasError('required', 'password',loginForm)">
                                            {{ 'AUTH.VALIDATION.REQUIRED_FIELD'| translate }}
                                        </div>
                                    </div>
                                </div>
                                <ng-container *ngIf="hasError">
                                    <div class="alert alert-danger d-flex align-items-center" role="alert">
                                        <svg class="bi flex-shrink-0 me-2" width="24" height="24" role="img"
                                            aria-label="Danger:">
                                            <use xlink:href="#exclamation-triangle-fill" />
                                        </svg>
                                        <div>
                                            {{ ErrorMessage }}
                                        </div>
                                    </div>
                                </ng-container>
                                <div class="col-lg-12">
                                    <div class="text-center">
                                        <button type="submit" class="btn signup-btn">{{'AUTH.LOGIN.BUTTON' |
                                            translate}}</button>
                                        <ng-container *ngIf="isLoading$ | async">
                                            <div class="spinner-border" role="status" style="margin-top: 30px;">
                                                <span class="visually-hidden"></span>
                                            </div>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>